import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DsButtonComponent } from './buttons/ds-button/ds-button.component';
import { DsCardActionsComponent } from './cards/ds-card-actions/ds-card-actions.component';
import { DsCardBadgeComponent } from './cards/ds-card-badge/ds-card-badge.component';
import { DsCardBodyComponent } from './cards/ds-card-body/ds-card-body.component';
import { DsCardMediaComponent } from './cards/ds-card-media/ds-card-media.component';
import { DsCardTitleComponent } from './cards/ds-card-title/ds-card-title.component';
import { DsCardComponent } from './cards/ds-card/ds-card.component';
import { DsProgressBarComponent } from './cards/ds-progress-bar/ds-progress-bar.component';
import { DsProgressRingComponent } from './cards/ds-progress-ring/ds-progress-ring.component';

const PRIMITIVES = [
  DsCardComponent,
  DsCardMediaComponent,
  DsCardBodyComponent,
  DsCardActionsComponent,
  DsCardTitleComponent,
  DsProgressBarComponent,
  DsProgressRingComponent,
  DsCardBadgeComponent,
  DsButtonComponent
];

@NgModule({
  declarations: PRIMITIVES,
  imports: [CommonModule],
  exports: PRIMITIVES
})
export class DesignSystemModule {}
